(() => {
  const addChevronEventListener = () => {
    document.querySelectorAll(".swatches-chevron").forEach((ch) => {
      ch.addEventListener("mousedown", (e) => {
        const scrollValue = e.currentTarget.classList.contains(
          "swatches-chevron-left"
        )
          ? -50
          : 50;
        const productId = e.currentTarget.getAttribute("data-product-id");

        const fieldsetWrapper = document.getElementById(
          "fieldsetWrapper-" + productId
        );

        fieldsetWrapper.scrollBy(scrollValue, 0);
      });
    });
  };

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.classList && node.classList.contains("product-grid"))
            addChevronEventListener();
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  addChevronEventListener();
})();
